import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import ToastProvider from 'Components/HOC/ToastProvider';
import Toast from '../Toast';
import { messageSelectors } from 'Ducks';

import styles from './styles.module.scss';

const ToastWrapper = ({ className, toasts }) =>
	!!(toasts && !!toasts.length) && (
		<ToastProvider
			isOpen
			containerId='toast-container'
		>
			<div className={`toasts_zIndex ${styles.toasts} ${className}`}>
				{toasts.reverse().map((toast) => {
					return (
						<div
							key={toast.id}
							id={toast.id}
						>
							<Toast
								message={toast.title}
								type={toast.type}
								id={toast.id}
								time={toast.toastTime}
								className={styles.toasts__item}
							/>
						</div>
					);
				})}
			</div>
		</ToastProvider>
	);

ToastWrapper.propTypes = {
	className: PropTypes.string,
	toasts: PropTypes.array,
};

ToastWrapper.defaultProps = {
	className: '',
	toasts: [],
};

const mapStateToProps = (state) => ({
	toasts: messageSelectors.selectToasts(state),
});

export default connect(mapStateToProps)(ToastWrapper);
